import LoginPage from "Pages/LoginPage/LoginPage";
import { Navigate } from "react-router-dom";
import { useAuth } from "utilFunctions/CustomHooks/useAuth";

export const HomeLayout = () => {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <LoginPage />;
};
